import axios from 'axios'
//  import qs from 'qs'

export const groupCourseService = ({
  listGroupCoursesMaster (token, groupId) {
    return axios.get('/api/GroupCourses?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteGroup (token, gcmId) {
    return axios.delete('/api/GroupCourse/Delete?gcmId=' + gcmId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getGroupCourseList (token) {
    return axios.get('/api/GroupCourses/ListAll', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getGroupCourseUsers (token, groupCourseMasterId) {
    return axios.get('api/GroupCourse/Users?groupCourseMasterId=' + groupCourseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getUsersInGroupCourses (token, groupCourseMasterIds) {
    var stringifiedObj = JSON.stringify(groupCourseMasterIds) // qs.stringify(groupCourseMasterIds)
    return axios.put('api/GroupCourse/UsersInGroupCourses', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  getCourseJourney (token, courseMasterId) {
    return axios.get('/api/CourseMaster/Journey?courseMasterId=' + courseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAvailableM365 (token, groupId) {
    return axios.get('/api/GroupCourses/AvailableM365?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  listElectivesGroups (token, groupId) {
    return axios.get('/api/GroupCourses/GetAllElectives?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  listGroupCourseCohortForMeetingMentor (token, groupId) {
    return axios.get('/api/leaps/availablecohorts?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  listAssociatedGroupMeditationAndReflectionList (token, groupId) {
    return axios.get('/api/leaps/AvailableMeditationAndReviewQuestionForGroup?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/group-course-service.js